import { PlusOutlined } from '@ant-design/icons';
import { Button, Input, Tag } from 'antd';
import { useState } from 'react';

interface TagsInputProps {
  value?: string[];
  onChange?: (tags: string[]) => void;
}

const TagsInput: React.FC<TagsInputProps> = ({ value = [], onChange }) => {
  const [newTag, setNewTag] = useState('');

  const handleAddTag = () => {
    if (newTag && !value.includes(newTag)) {
      onChange?.([...value, newTag]);
      setNewTag('');
    }
  };

  const handleRemoveTag = (tagToRemove: string) => {
    onChange?.(value.filter((tag) => tag !== tagToRemove));
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap gap-2">
        {value.map((tag) => (
          <Tag key={tag} closable onClose={() => handleRemoveTag(tag)}>
            {tag}
          </Tag>
        ))}
      </div>
      <div className="flex gap-2">
        <Input
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          placeholder="Enter new tag"
          onPressEnter={handleAddTag}
        />
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddTag}>
          Add
        </Button>
      </div>
    </div>
  );
};

export default TagsInput;
